import moment from "moment";

import { CROP_TYPE_FCPO, CropItemData, FieldPracticeResponse } from "models";

import { GROUP_TYPE, PRACTICE_TYPE, TimelineCalendarItemsProps } from "pages/app/field-timeline/components/FieldDetailsTimeline.tsx";

export const getCropGroupType = (cropType: CROP_TYPE_FCPO) => {
  switch (cropType) {
    case CROP_TYPE_FCPO.MAIN:
      return GROUP_TYPE.MAIN_CROP;
    case CROP_TYPE_FCPO.COVER:
    case CROP_TYPE_FCPO.UNDERSOWING:
      return GROUP_TYPE.SIDE_CROP;
    default:
      return GROUP_TYPE.MAIN_CROP;
  }
};

export const getCropPracticeType = (cropType: CROP_TYPE_FCPO) => {
  switch (cropType) {
    case CROP_TYPE_FCPO.MAIN:
      return PRACTICE_TYPE.MAIN_CROP;
    case CROP_TYPE_FCPO.UNDERSOWING:
      return PRACTICE_TYPE.UNDERSOWING_CROP;
    case CROP_TYPE_FCPO.COVER:
      return PRACTICE_TYPE.COVER_CROP;
    default:
      return PRACTICE_TYPE.UNKNOWN;
  }
};

export const createCropItems = (
  fieldCropOverviewResponse: FieldPracticeResponse,
  baselineYears: number[],
  isMandatory: boolean
): TimelineCalendarItemsProps<CropItemData>[] =>
  fieldCropOverviewResponse.crops.map((crop) => {
    const item: TimelineCalendarItemsProps<CropItemData> = {
      id: crop.id,
      title: crop.cropName,
      start_time: moment(crop.seedingStartDate),
      end_time: moment(crop.harvestEndDate),
      group: getCropGroupType(crop.cropType as CROP_TYPE_FCPO),
      // TODO: re-add resizing
      // canResize: "both",
      canResize: false,
      cropItemId: crop.id,
      practiceType: getCropPracticeType(crop.cropType as CROP_TYPE_FCPO),
      data: {
        cropType: crop.cropType,
        cropName: crop.cropName,
        hasResidue: crop.hasResidue,
        payout: crop.payout <= 0 ? undefined : crop.payout,
        isMandatory: isMandatory,
        isBaseline: baselineYears.includes(crop.year!),
        isConfirmed: !!crop.isConfirmed,
        year: crop.year,
        fertilizerManagements: fieldCropOverviewResponse.fertilizerManagements,
        yieldTonsPerHa: crop.yieldTonsPerHa,
        cropMixId: crop.cropMixId,
      },
    };
    return item;
  });
